import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AppToastService} from '../../../shared/services/util/app-toast.service';
import {UtilityService} from '../../../shared/services/util/utility.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {SettingsService} from '../../../core/settings/settings.service';
import {AuthenticationService} from '../../../shared/services/authentication.service';
import {first} from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class LoginComponent implements OnInit {

  loading = false;
  hide = true;
  toasterConfig: any;
  formGroup: UntypedFormGroup;
  returnUrl: string;

  constructor(private appToastService: AppToastService,
              public utilityService: UtilityService,
              private formBuilder: UntypedFormBuilder,
              private authenticationService: AuthenticationService,
              public settingsService: SettingsService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.toasterConfig = this.appToastService.getConfig();
    // redirect to home if already logged in
    if (this.authenticationService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.createForm();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.activatedRoute.snapshot.queryParams.returnUrl || '/';
  }

  createForm(): void {
    this.formGroup = this.formBuilder.group({
      username: new UntypedFormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.maxLength(50)]),
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(16)])
    });
  }

  getErrorUser() {
    return this.fg.username.hasError('required') ? 'You must enter a value' :
      this.fg.username.hasError('email') ? 'Not a valid email' :
        this.fg.username.hasError('minlength') ? 'Not a valid username minim length 4' :
          this.fg.username.hasError('maxlength') ? 'Not a valid username maxim length 50' :
            '';
  }

  getErrorPassword() {
    return this.fg.password.hasError('required') ? 'You must enter a value' :
      this.fg.password.hasError('minlength') ? 'Not a valid password minim length 4' :
        this.fg.password.hasError('maxlength') ? 'Not a valid password maxim length 16' :
          '';
  }

  // convenience getter for easy access to form fields
  get fg() {
    return this.formGroup.controls;
  }

  onSubmit() {
    this.loading = true;
    this.authenticationService.login(this.fg.username.value, this.fg.password.value)
      .pipe(first())
      .subscribe({
        next: () => {
          this.loading = false;
          this.router.navigate([this.returnUrl]);
        },
        error: error => {
          this.loading = false;
          this.appToastService.error('Error ', error);
        }
      });
  }

}
